/* /upgrade/canceled — friendly return when the buyer bails at Stripe. */
import { useNavigate } from 'react-router-dom';
import { motion } from 'framer-motion';
import { ArrowLeft, Crown } from 'lucide-react';

export default function UpgradeCanceled() {
  const nav = useNavigate();
  return (
    <div data-testid="upgrade-canceled-root" className="space-y-5 pb-24">
      <div className="flex items-center gap-2">
        <button
          data-testid="upgrade-canceled-back"
          onClick={() => nav('/upgrade', { replace: true })}
          className="p-1.5 rounded-full glass border border-white/10">
          <ArrowLeft className="w-4 h-4" />
        </button>
        <div>
          <p className="text-[10px] uppercase tracking-widest text-accent">Membership</p>
          <h1 className="font-serif text-3xl leading-tight">No worries — you're still an Explorer</h1>
        </div>
      </div>

      <motion.div
        initial={{ opacity: 0, y: 10 }} animate={{ opacity: 1, y: 0 }}
        className="rounded-3xl glass border border-white/10 p-4 space-y-3">
        <p className="text-sm text-white/80 leading-relaxed">
          Your progress is untouched. You can upgrade any time — the trail is right where you left it.
        </p>
        <button
          data-testid="upgrade-canceled-retry"
          onClick={() => nav('/upgrade', { replace: true })}
          className="w-full h-11 rounded-full bg-accent text-black text-[11px] uppercase tracking-widest flex items-center justify-center gap-2">
          <Crown className="w-3.5 h-3.5" /> See plans again
        </button>
        <button
          data-testid="upgrade-canceled-dashboard"
          onClick={() => nav('/dashboard', { replace: true })}
          className="w-full h-10 rounded-full border border-white/10 bg-white/5 text-[11px] uppercase tracking-widest">
          Continue exploring
        </button>
      </motion.div>
    </div>
  );
}
